export default {
  GPS: 'GPS',
  featureComingSoon: 'This feature is coming soon...',
  assign: 'Assign',

};